import React from 'react'
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"

const FileField = ({fieldClass, labelClass, type, name, value, required, placeholder, handlechange, accept, label, grpmd}) => (
  <Form.Group as={Col} md={grpmd} controlId={"validation" + name}>
    { label
      ? <p className={`label-wrap ${labelClass}`}><Form.Label className={`file-form-label`}>{label}{required ? '' : ''}</Form.Label></p>
      : ''
    }
    <div className={fieldClass}>
      <Form.Control
       controlId="custom-file"
        required={required}
        type={type}
        name={name}
        value={value}
        onChange={handlechange}
        accept={accept}
        id="custom-file"
      />
      <label for="custom-file" className="custom-file-label">{placeholder}</label>
    </div>
  </Form.Group>
);

export default FileField;
